import type { Components, Theme } from '@mui/material'

type MuiMenuSettings = Components<Omit<Theme, 'components'>>['MuiMenu']

export const MuiMenu: MuiMenuSettings = {
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: '8px',
      border: `1px solid ${theme.palette.grey[200]}`,
      boxShadow: 'none',
      maxHeight: '320px !important',
    }),
    list: {
      padding: '8px',
    },
  },
}
